const DELETE_CUSTOMER_PROPERTIES_URL = '/property/delete-customer-property';
const ADD_NEW_CUSTOMER = '/customer/add';
const EDIT_CUSTOMER = '/customer/edit';
const COUNTRIES_DATA = '/webservice/countries-data';
const GET_CUSTOMER_CONSTRAINS = '/customer/getCustomerConstrains';
const UPDATE_BOOKING_CUSTOMERS = '/customer/updateBookingCustomer';
const STORE_IMAGE_TO_TEMP_BUCKET = 'webservice/store-image-to-temp-bucket';
const INITIALIZE_CUSTOMER_INFO_COMPONENT = '/webservice/get-customer-info';
const CHANGE_BOOKING_LOCATION_API = '/webservice/update-booking-location';


function buildFormData(formData, data, parentKey) {
    if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
        Object.keys(data).forEach(key => {
            buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
        });
    } else {
        const value = data == null ? '' : data;
        formData.append(parentKey, value);
    }
}

module.exports = {

    uploadSignature: function uploadSignature({image, customer_id, attribute_id}) {
        let image_type = 'signature';
        const formData = new FormData();
        formData.append('image', image);
        formData.append('customer_id', customer_id);
        formData.append('attribute_id', attribute_id);
        formData.append('image_type', image_type);
        formData.append('for_ajax', true);
        return window.axios.post(STORE_IMAGE_TO_TEMP_BUCKET, formData);
    },
    deleteCustomerProperties: function deleteCustomerProperties(toBeDeletedProperty) {
        let form = new FormData();
        form.set('id', toBeDeletedProperty.customer_property_id);
        return window.axios.post(DELETE_CUSTOMER_PROPERTIES_URL, form, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        });
    },
    addNewCustomer: function addNewCustomer(data) {
        let form = new FormData();
        buildFormData(form, data);

        return window.axios.post(ADD_NEW_CUSTOMER, form, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        });
    },
    editCustomer: function editCustomer(customerId, data) {
        let form = new FormData();
        buildFormData(form, data);

        return window.axios.post(EDIT_CUSTOMER+'/'+customerId, form, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        });
    },
    getCountriesData:function getCountriesData(params){
        return window.axios.get(COUNTRIES_DATA, {params: params});
    },
    getCustomerConstrains:function getCustomerConstrains(params){
        return window.axios.get(GET_CUSTOMER_CONSTRAINS, {params: params});
    },
    initalizeCustomerInfoComponent: function initalizeCustomerInfoComponent(params){
        return window.axios.get(INITIALIZE_CUSTOMER_INFO_COMPONENT, {params: params});
    },
    changeBookingLocationApi: function changeBookingLocationApi(customer_id,item_id,item_type){
        let form = new FormData();
        form.set('customer_id', customer_id);
        form.set('item_id', item_id);
        form.set('item_type', item_type);
        return window.axios.post(CHANGE_BOOKING_LOCATION_API, form, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        });
    },

    updateBookingCustomers: function updateBookingCustomers(bookingId,customers){
        let form = new FormData();
        form.set('customers', customers);
        form.set('booking_id', bookingId);
        return window.axios.post(UPDATE_BOOKING_CUSTOMERS, form, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        });
    }
};
